import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import zeplinColor from 'theme/Color';
import Card from './Card';

const Companies = ({ loading, data }: { loading: boolean; data: any }) => {
  const [total, setTotal] = useState(0);

  return (
    <Box sx={{ display: 'flex', gap: { xs: '20px', xl: '32px' }, height: 'calc(100vh - 350px)' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
          overflowY: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 1,
          }}
        >
          <Typography variant='responsiveHeading3'>Similar companies</Typography>
          <InfiniteScroll
            dataLength={data?.length || 0}
            loader={
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <></>
              </Box>
            }
            next={() => {}}
            hasMore={data?.data?.length < total}
            height={'calc(100vh - 350px)'}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: '100%',
            }}
          >
            {!data ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flex: 1,
                  height: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} alt='no zoominfo results' />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No similar companies
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(2,1fr)',
                    xl: 'repeat(3,1fr)',
                  },
                  gap: '24px',
                  overflowY: 'auto',
                  gridAutoRows: 'min-content',
                  gridAutoFlow: 'row',
                  flex: 1,
                }}
              >
                {loading
                  ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((val) => (
                      <Card val={val} loading={loading} />
                    ))
                  : data?.map((val: any) => (
                      <Link
                        to={`/zoominfo/${val?.id ?? ''}`}
                        style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                      >
                        <Box
                          sx={{
                            borderRadius: '14px',
                            padding: '12px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            backgroundColor: zeplinColor.Neutral3,
                            ':hover': {
                              backgroundColor: zeplinColor.Neutral4,
                            },
                            alignItems: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              gap: '12px',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              sx={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '8px',
                                backgroundColor: zeplinColor.Neutral1,
                              }}
                            >
                              <img
                                src={val?.logo}
                                width='48px'
                                height='48px'
                                alt='industry'
                                style={{ objectFit: 'contain', borderRadius: '8px' }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                                }}
                              />
                            </Box>
                            <Typography sx={{ fontSize: '18px' }} color={zeplinColor.BasicBlack}>
                              {val?.name}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              width: '24px',
                              height: '24px',
                              backgroundColor: zeplinColor.Neutral10,
                              borderRadius: '50px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            onClick={() => {}}
                          >
                            <img src='/assets/arrow-next-white.svg' alt='arrow-next' />
                          </Box>
                        </Box>
                      </Link>
                    ))}
              </Box>
            )}
          </InfiniteScroll>
        </Box>
      </Box>
    </Box>
  );
};

export default Companies;
